import React from 'react';
import { Box, Typography } from '@mui/material';
import { CalendarEventDto } from '@/types/calendar';

interface Props {
  event: CalendarEventDto;
}

export const FluidEventDetails: React.FC<Props> = ({ event }) => {
  const d = event.details;
  if (!d) return null;

  const rows: { label: string; value: string }[] = [];

  if (d.qty != null) rows.push({ label: "Об'єм", value: `${d.qty} мл` });
  if (d.fluidType) rows.push({ label: 'Тип', value: d.fluidType });
  if (d.notes) rows.push({ label: 'Нотатки', value: d.notes });

  if (!rows.length) return null;

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '4px 16px', alignItems: 'baseline' }}>
      {rows.map(({ label, value }) => (
        <React.Fragment key={label}>
          <Typography variant="body2" color="text.secondary">{label}</Typography>
          <Typography variant="body2">{value}</Typography>
        </React.Fragment>
      ))}
    </Box>
  );
};
